import STATICS from '../event.statics'

const getDefaultFilters = () => ({
  minPrice: STATICS.MIN_PRICE[0],
  maxPrice: STATICS.MAX_PRICE[0],
  beds: STATICS.BEDS[0],
  baths: STATICS.BATHS[0],
  sqft: STATICS.SQFT[0],
  occupancyStatus: STATICS.OCCUPANCY_STATUS[0],
  yearBuiltFrom: { value: '' },
  yearBuiltTo: { value: '' },
  stateFilter: STATICS.DEFAULT_STATE_FILTER,
  countyFilter: STATICS.DEFAULT_COUNTY_FILTER,
  cityFilter: STATICS.DEFAULT_CITY_FILTER,
  propertyTypeFilters: STATICS.PROPERTY_TYPE_FILTERS.reduce(
    (filters, propertyType) => ({
      ...filters,
      [propertyType.value]: false,
    }),
    {}
  ),
})

const getFiltersForApi = ({ propertyTypeFilters, ...otherFilters }) => {
  const result = {}

  const usecodePropertyType = Object.keys(propertyTypeFilters)
    .filter(key => !!propertyTypeFilters[key]) // check if checkbox is on
    .map(
      key =>
        STATICS.PROPERTY_TYPE_FILTERS.find(
          propertyType => propertyType.value === key
        ).usecodePropertyType
    )
    .join(',')

  if (usecodePropertyType) {
    result.usecode_property_type = usecodePropertyType
  }

  const apiFilters = Object.keys(otherFilters)
    .filter(key => !!otherFilters[key].value)
    .map(key => ({
      [STATICS.API_FILTER_KEYS[key]]: otherFilters[key].value,
    }))
    .reduce((filters, next) => ({ ...filters, ...next }), {})

  return { ...result, ...apiFilters }
}

export { getDefaultFilters, getFiltersForApi }
